import { render, staticRenderFns } from "./GoldbeanExchange.vue?vue&type=template&id=016fe314&scoped=true&"
import script from "./GoldbeanExchange.vue?vue&type=script&lang=ts&"
export * from "./GoldbeanExchange.vue?vue&type=script&lang=ts&"
import style0 from "./GoldbeanExchange.vue?vue&type=style&index=0&id=016fe314&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "016fe314",
  null
  
)

export default component.exports